import { render, staticRenderFns } from "./word_break.vue?vue&type=template&id=23e14f6c&lang=pug&"
import script from "./word_break.vue?vue&type=script&lang=js&"
export * from "./word_break.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('23e14f6c', component.options)
    } else {
      api.reload('23e14f6c', component.options)
    }
    module.hot.accept("./word_break.vue?vue&type=template&id=23e14f6c&lang=pug&", function () {
      api.rerender('23e14f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/typography/word_break.vue"
export default component.exports